<template>

  <b-input-group-append>
    <b-dropdown button-class="square-button" no-caret id="dropdown-search-history" text="" class="m-0 p-0" @show="getRecentSearches">
      <template #button-content>
        <b-icon-clock-history></b-icon-clock-history>
      </template>
      <b-dropdown-item-button v-for="(search, index) in searches" :key="index + 'searchHistoryItem'" @click.stop="doSearch(search)">
        <div class="dropdown-container d-flex flex-wrap align-items-center gap-2">
          <div class="flex-grow-1 my-1">
            <div class="dropdownItem d-flex flex-wrap align-items-center gap-2" v-html="generateList(search)"></div>
          </div>
          <div class="buttons my-1 mx-1 my-1">
            <b-button size="sm" @click.stop="deleteSearch(index)"><b-icon-trash></b-icon-trash></b-button>
          </div>
        </div>
      </b-dropdown-item-button>
      <b-dropdown-item-button disabled v-if="searches.length === 0">
        No search history.
      </b-dropdown-item-button>
    </b-dropdown>
  </b-input-group-append>



</template>

<script>
  import searchFilterNamesMixin from "../../assets/searchFilterNames";

  export default {
      name: "SearchHistory",
      mixins: [ searchFilterNamesMixin ],
      data() {
          return {
            searches: []
          }
      },
      methods: {
            doSearch(search) {
              this.$emit('setSearch', search);
              this.$nextTick(()=> {
                this.$bvModal.hide("searchHistoryModal")
              })
            },
            getRecentSearches() {
              const recentSearches = JSON.parse(localStorage.getItem('recentSearches')) || [];
              this.searches = recentSearches;
            },
            deleteSearch(index) {
              const recentSearches = JSON.parse(localStorage.getItem('recentSearches')) || [];
              recentSearches.splice(index, 1);
              localStorage.setItem('recentSearches', JSON.stringify(recentSearches));
              this.searches = recentSearches;
            },
            filterName(filter) {
                return this.searchFilterNames[filter];
            },
            generateList(inputObject) {
            let spans = [];

            // Check and append query value
            if (inputObject.query) {
              spans.push(`<span class="searchHistoryTag"><span class="filter">Search:</span> <span class="search-history-value">${inputObject.query}</span></span>`);
            }

            // Check and append catalog number
            if (inputObject.catalogNumber) {
              spans.push(`<span class="searchHistoryTag"><span class="filter">Catalog No.:</span> <span class="search-history-value">${inputObject.catalogNumber}</span></span>`);
            }

            // Check for Added and Added To values
            const addedValue = inputObject.filters.added;
            const addedToValue = inputObject.filters.addedTo;

            if (addedValue !== null) {
              // Combine Added and Added To with ' - ' if Added To is defined
              if (addedToValue !== undefined) {
                spans.push(`<span class="searchHistoryTag"><span class="filter">${this.searchFilterNames['added']}:</span> <span class="search-history-value">${addedValue?.replace(/-/g, '/')} - ${addedToValue !== null ? addedToValue?.replace(/-/g, '/') : ''}</span></span>`);
              } else {
                spans.push(`<span class="searchHistoryTag"><span class="filter">${this.searchFilterNames['added']}:</span> <span class="search-history-value">${addedValue?.replace(/-/g, '/')}</span></span>`);
              }
            } else if (addedToValue !== undefined && addedToValue !== null) {
              // Include Added To only if Added is not defined
              spans.push(`<span class="searchHistoryTag"><span class="filter">${this.searchFilterNames['addedTo']}:</span> <span class="search-history-value">${addedToValue?.replace(/-/g, '/')}</span></span>`);
            }

            // Check for Order Date and Order Date To values
            const orderDateValue = inputObject.filters.orderDate;
            const orderDateToValue = inputObject.filters.orderDateTo;

            if (orderDateValue !== null) {
              // Combine Order Date and Order Date To with ' - ' if Order Date To is defined
              if (orderDateToValue !== undefined) {
                spans.push(`<span class="searchHistoryTag"><span class="filter">Ordered:</span> <span class="search-history-value">${orderDateValue?.replace(/-/g, '/')} - ${orderDateToValue !== null ? orderDateToValue?.replace(/-/g, '/') : ''}</span></span>`);
              } else {
                spans.push(`<span class="searchHistoryTag"><span class="filter">Ordered:</span> <span class="search-history-value">${orderDateValue?.replace(/-/g, '/')}</span></span>`);
              }
            } else if (orderDateToValue !== undefined && orderDateToValue !== null) {
              // Include Order Date To only if Order Date is not defined
              spans.push(`<span class="searchHistoryTag"><span class="filter">${this.searchFilterNames['orderDateTo']}:</span> <span class="search-history-value">${orderDateToValue?.replace(/-/g, '/')}</span></span>`);
            }

            // Loop through filters and append non-null and true boolean values
            for (const key in inputObject.filters) {
              const value = inputObject.filters[key];

              // Exclude 'itemIds', 'added', 'addedTo', 'orderDate', and 'orderDateTo' from the output they have been handled
              if (
                key !== 'itemIds' &&
                key !== 'added' &&
                key !== 'addedTo' &&
                key !== 'orderDate' &&
                key !== 'orderDateTo' &&
                (value !== null && (typeof value !== 'boolean' || value))
              ) {
                if (typeof value === 'boolean') {
                  spans.push(`<span class="searchHistoryTag"><span class="filter"><span class="search-history-value">${this.searchFilterNames[key]}</span></span></span>`);
                } else {
                  spans.push(`<span class="searchHistoryTag"><span class="filter">${this.searchFilterNames[key]}:</span> <span class="search-history-value">${value}</span></span>`);
                }
              }
            }

            return spans.join(' ');
            }
          }
      }
</script>

<style>
  .searchHistoryTag {
    background: #ddd;
    padding: 4px 8px;
    margin: 4px;
    border-radius: 4px;
  }

  .dropdown-container {
    width: 50vw;
  }

  .square-button {
    border-radius: 0px;
  }

  
</style>